import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Heading from '../heading/Heading';
import UploadDragDropFiles from '../upload-drag-drop-files/UploadDragDropFiles';
import validateFile from '../../services/validateFile';
import FileList from '../file-list/FileList';
import Textarea from '../form/inputs/Textarea';
import CheckboxRadio from '../form/checkbox/CheckboxRadio';
import Text from '../text/Text';
import Input from '../form/inputs/Input';
import Checkbox from '../form/checkbox/Checkbox';
import { authorizedPersons } from '../../reducers/SecondStep';
import getDataByPostalCode from '../../services/getDataByPostalCode';
import ModalDocuments from '../static-modals/ModalDocuments';

const Attachments = ( props ) => {
    let [ load, setLoad ]             = useState(false);
    let [ buttonError, setButtonError ]             = useState(false);
    let [ openedModal, setOpenedModal ]             = useState(false);

    let [ buttonText, setButtonText ]               = useState("Select or drag & drop file");
    let [ update, setUpdate ]                       = useState(0);
    let [ updateArray, setUpdateArray ]             = useState(0);
    let [ customerEmail, setCustomerEmail ]         = useState('');

    const dispatch                        = useDispatch()
    let attachmentsFiles                  = useSelector(state => state.attachmentsFiles)
    let comments                          = useSelector(state => state.comments)
    let postman                           = useSelector(state => state.postman)
    let courier                           = useSelector(state => state.courier)
    let productPrice                      = useSelector(state => state.productPrice)
    let showEsign                         = useSelector(state => state.showEsign)
    let showEsignMaxPrice                 = useSelector(state => state.showEsignMaxPrice)
    let esign                             = useSelector(state => state.esign)
    let esignForceVisible                 = useSelector(state => state.esignForceVisible)
    let authorizedPersons                 = useSelector(state => state.authorizedPersons)
    let esignPersons                      = useSelector(state => state.esignPersons)
    let email                             = useSelector(state => state.email)   
    let phone                             = useSelector(state => state.phone)   
    let realEstatesFiles                  = useSelector(state => state.realEstatesFiles);
    let fundsFiles                        = useSelector(state => state.fundsFiles);
    let otherCreditsFiles                 = useSelector(state => state.otherCreditsFiles);
    let fvFile                            = useSelector(state => state.fvFile);
    let providerPostal                    = useSelector(state => state.providerPostal);
    
      useEffect(() => {
        
        if ( !load ) {
            dispatch({ type: 'ESIGN_PERSONS_CHANGE', value: authorizedPersons }) 
            checkPostalCode();
            setLoad(true)
        }

    }, [ load ]);

      useEffect(() => {
          setUpdate(update + 1);
      }, [attachmentsFiles]);

      useEffect(() => {
          if ( esign || esignForceVisible ) {
            if (    esignPersons[0]['name'].length === 0 || 
                    esignPersons[0]['surname'].length === 0  ||
                    esignPersons[0]['phone'].length === 0  ||
                    esignPersons[0]['email'].length === 0 
                )  {
                    dispatch({ type: 'ESIGN_CHANGE', value: false })
                } else {
                    dispatch({ type: 'ESIGN_CHANGE', value: true })
                }
          }
            
      }, [updateArray])

    //   let setFiles = (val) => {
    //     let files = attachmentsFiles;
    //     for (let i = 0; i < val.length; i++) {
    //         const el = val[i];
    //         let validate = validateFile(1048576, 5, files.length, el.file);
    //         setButtonError( validate.error )
    //         setButtonText( validate.message )
    //         if ( !validate.error ) {
    //         files.push(el);
    //         }
    //     }          
    //     dispatch({ type: 'ATTACHMENTS_FILES_CHANGE', value: files })
    //     setUpdate(++update);
    // }
    // let removeFile = ( title ) => {
    //     let files = attachmentsFiles;
    //     files = files.filter(item => item.title != title);
    //     dispatch({ type: 'ATTACHMENTS_FILES_CHANGE', value: files })
    //     setUpdate(--update);
    //     setButtonError( false )
    // }

    let setFiles = (files) => {
        dispatch({ type: 'ATTACHMENTS_FILES_CHANGE', value: files });
        setUpdate(update + 1);
    }
    let removeFile = ( title ) => {
        let files = attachmentsFiles.filter(item => item.title !== title);
        dispatch({ type: 'ATTACHMENTS_FILES_CHANGE', value: files });
        setUpdate(update - 1);
        setButtonError(false);
    }

    let checkPostalCode = async () => {
        let data = await getDataByPostalCode(providerPostal);
        // console.log(data)
        if ( data.status == 'done' ) {
            setCustomerEmail(data.email);
        } else {
            setCustomerEmail('service@grenke.pl');
        }
    }

    let oldFiles=[  ...fvFile, 
                    ...realEstatesFiles,
                    ...fundsFiles,
                    ...otherCreditsFiles
    ]
    
    return (
        <>
        <Heading title="Required Attachments" 
                medium
                moreMarginTop
                borderBottomDotted
                class=""
                tip={ true } 
                tipHeader="Attachment formats"
                tipText="The required formats for attachments are: PDF / JPG / PNG." />
        <div className="attachments">
            <div className="row">
                { update && update >= 0 &&
                    <UploadDragDropFiles 
                        // setFunction={ ( val ) => setFiles(val)  }
                        data={attachmentsFiles.filter(item => item.title == "Trade license copy")[0]}
                        setFunction={setFiles}
                        files={attachmentsFiles}
                        title={"Trade license copy"}
                        buttonText={ buttonText }
                        error={ buttonError } 
                        remove={ (title) => removeFile( title ) } 
                        required
                        forceValidate={props.forceValidate}
                        update={update} /> 
                }
                { update && update >= 0 &&
                    <UploadDragDropFiles 
                        // setFunction={ ( val ) => setFiles(val)  }
                        data={attachmentsFiles.filter(item => item.title == "Copy of Passport")[0]}
                        setFunction={setFiles}
                        files={attachmentsFiles}
                        title={"Copy of Passport"}
                        buttonText={ buttonText }
                        error={ buttonError } 
                        remove={ (title) => removeFile( title ) } 
                        required
                        forceValidate={props.forceValidate}
                        update={update} /> 
                }
                { update && update >= 0 &&
                    <UploadDragDropFiles 
                        // setFunction={ ( val ) => setFiles(val)  }
                        data={attachmentsFiles.filter(item => item.title == "Copy of Emirates ID")[0]}
                        setFunction={setFiles}
                        files={attachmentsFiles}
                        title={"Copy of Emirates ID"}
                        buttonText={ buttonText }
                        error={ buttonError } 
                        remove={ (title) => removeFile( title ) } 
                        required
                        forceValidate={props.forceValidate}
                        update={update} /> 
                }
            </div>
        </div>
        <Heading title="Additional Attachments" 
                medium
                moreMarginTop
                borderBottomDotted
                class=""
                tip={ true } 
                tipHeader="Attachment formats"
                tipText="The required formats for attachments are: PDF / JPG / PNG." />
        <div className="attachments">
            <div className="row">
                { update && update >= 0 &&
                    <UploadDragDropFiles 
                        // setFunction={ ( val ) => setFiles(val)  }
                        data={attachmentsFiles.filter(item => item.title == "Proforma Invoice / quotation")[0]}
                        setFunction={setFiles}
                        files={attachmentsFiles}
                        title={"Proforma Invoice / quotation"}
                        buttonText={ buttonText }
                        error={ buttonError } 
                        remove={ (title) => removeFile( title ) } 
                        update={update} /> 
                }
                { update && update >= 0 &&
                    <UploadDragDropFiles 
                        // setFunction={ ( val ) => setFiles(val)  }
                        data={attachmentsFiles.filter(item => item.title == "Copy of Visa")[0]}
                        setFunction={setFiles}
                        files={attachmentsFiles}
                        title={"Copy of Visa"}
                        buttonText={ buttonText }
                        error={ buttonError } 
                        remove={ (title) => removeFile( title ) } 
                        update={update} /> 
                }
            </div>
        </div>
        </>
    )
}

export default Attachments;